import { http, HttpResponse } from 'msw'

import { getResponseObject } from '@webapp/tests'
import { CardApiModelStub } from '../api-models/stubs/CardApiModel.stub'

export const mockGetMyPhysicalCardSuccessResponse = (
  cardStub = CardApiModelStub.build()
) => {
  return http.get(
    `/api/v3/pay/my-card/`,
    () => {
      return HttpResponse.json(getResponseObject({ card: cardStub }), {
        status: 200,
      })
    },
    { once: true }
  )
}
